import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { motion } from "framer-motion";

export const GoldButton = ({ to, href, children, testId, className = "", ...rest }) => {
  const cls = `group inline-flex h-14 items-center justify-center gap-3 rounded-full bg-[#D4AF37] px-7 text-[15px] font-medium text-[#07040D] shadow-[0_0_40px_rgba(212,175,55,0.25)] transition-[background-color,box-shadow,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#F3E5AB] hover:shadow-[0_0_60px_rgba(212,175,55,0.45)] ${className}`;
  const inner = (
    <>
      {children}
      <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#07040D] text-[#D4AF37] transition-transform duration-300 group-hover:rotate-45">
        <ArrowUpRight className="h-4 w-4" />
      </span>
    </>
  );
  if (to) return <Link to={to} data-testid={testId} className={cls} {...rest}>{inner}</Link>;
  return <a href={href} data-testid={testId} className={cls} {...rest}>{inner}</a>;
};

export const GhostButton = ({ href, children, testId, icon: Icon = Phone, className = "", ...rest }) => (
  <motion.a
    whileTap={{ scale: 0.97 }}
    href={href}
    data-testid={testId}
    className={`inline-flex h-14 items-center justify-center gap-2.5 rounded-full border border-[#D4AF37]/35 bg-[#07040D]/40 px-6 text-[15px] text-slate-100 backdrop-blur-md transition-[border-color,background-color] duration-300 hover:border-[#D4AF37] hover:bg-[#D4AF37]/10 ${className}`}
    {...rest}
  >
    <Icon className="h-4 w-4 text-[#D4AF37]" />
    {children}
  </motion.a>
);
